import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

interface OfferConvertConfirmDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  /** Antall linjer på tilbudet — brukes til å advare om tomt budsjett. */
  lineCount: number;
  /** Kalles når PL bekrefter. Page-komponenten åpner deretter den faktiske
   * convert-dialogen. */
  onConfirm: () => void;
}

/**
 * Bekreftelsesdialog før et tilbud konverteres til prosjekt. Splittet ut fra
 * OfferEditPage (VIB-658) for å holde page-orkestratoren under 300 linjer.
 * Inneholder ingen forretningslogikk — viser kun advarsel og delegerer
 * neste steg til parent.
 */
export function OfferConvertConfirmDialog({
  open,
  onOpenChange,
  lineCount,
  onConfirm,
}: OfferConvertConfirmDialogProps) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Konverter tilbud til prosjekt?</AlertDialogTitle>
          <AlertDialogDescription>
            Dette oppretter et nytt prosjekt i Sølvrev og i PowerOffice,
            med budsjettlinjer fra tilbudet. Tilbudet kobles til prosjektet
            og markeres som akseptert. Handlingen kan ikke enkelt reverseres.
            {lineCount === 0 && (
              <span className="block mt-2 text-amber-600">
                Obs: tilbudet har ingen linjer — prosjektet opprettes uten budsjett.
              </span>
            )}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Avbryt</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm}>
            Ja, fortsett
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
